import { ReactElement } from 'react'
import { useDispatch } from 'react-redux'
import { ActionButton, FlexWrapper, PageWrapper } from '../../../components'
import { getClearCourse, getClearMaterial } from '../../../redux/learnSession/api'

const Cache = (): ReactElement => {
    const dispatch = useDispatch() 
    return (
        <PageWrapper>
            <FlexWrapper justifyContent='center'>
                {` Warning! Please don't use without admin permission.`}
            </FlexWrapper>
            <FlexWrapper justifyContent='center'>
                <ActionButton variant="danger" onClick={() => dispatch(getClearCourse())}>Clear Course Cache</ActionButton>
                <ActionButton variant="danger" onClick={() => dispatch(getClearMaterial())}>Clear Material Cache</ActionButton>
            </FlexWrapper>
        </PageWrapper>
    )
}

export default Cache